import React, { useState } from 'react';
import { PayBenchmarkingFilterView } from 'apps/sigma2-ui/src/pay-benchmarking/components/PayBenchmarkingFilterView';
import { PayBenchmarkingInfoResultsView } from 'apps/sigma2-ui/src/pay-benchmarking/components/PayBenchmarkingInfoResultsView';
import { CustomViz } from 'apps/sigma2-ui/src/components/custom-viz/CustomViz';
import { useUser } from 'apps/sigma2-ui/src/state/user';
import { ShareLinkModal } from 'apps/sigma2-ui/src/components/ui/ShareLinkModal';
import { handleDownloadImage } from 'apps/sigma2-ui/src/components/ui/handle-download-image';
import { ObservationLocationType } from 'libs/end-to-end/src/observation-upload-type';
import { PayBenchmarkingCustomVizDefinition } from 'libs/end-to-end/src/custom-viz/PayBenchmarkingDefinition';
import { PayBenchmarking } from 'apps/sigma2-ui/src/pay-benchmarking/components/PayBenchmarking';

export const PayBenchmarkingView = ({
  observation,
  organizationId,
}: {
  observation: ObservationLocationType;
  organizationId: string;
}) => {
  const { userAuthenticatedApiCall } = useUser();

  const [showShareModal, setShowShareModal] = useState(false);

  const downloadImageRef = React.useRef<HTMLDivElement>(null);

  const onDownload = async () => {
    handleDownloadImage(downloadImageRef.current, 'pay-benchmarking');
  };

  const [currentShareLink, setCurrentShareLink] = useState<string>('');

  return (
    <>
      <CustomViz
        observation={observation}
        organizationId={organizationId}
        customVizDefinition={PayBenchmarkingCustomVizDefinition}
        userAuthenticatedApiCall={userAuthenticatedApiCall}
      >
        <PayBenchmarking
          observation={observation}
          organizationId={organizationId}
        >
          <div className="flex h-[calc(100vh-10rem)]">
            <div className="w-full bg-transparent">
              {showShareModal && (
                <ShareLinkModal
                  shareLink={currentShareLink}
                  showModal={showShareModal}
                  setShowModal={setShowShareModal}
                />
              )}
              <div
                className="flex justify-start gap-2 h-full w-full"
                ref={downloadImageRef}
              >
                <div className="p-2 bg-white rounded-2xl h-full">
                  <PayBenchmarkingFilterView />
                </div>

                <div className="bg-white rounded-2xl h-full grow">
                  <PayBenchmarkingInfoResultsView
                    organizationId={organizationId}
                    onDownload={onDownload}
                    onShare={(link) => {
                      setCurrentShareLink(link);
                      setShowShareModal(true);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </PayBenchmarking>
      </CustomViz>
    </>
  );
};
